import { useState, useEffect } from "react";
import navlogo from "../assets/nav-logo.png";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [activeSection, setActiveSection] = useState("home");
  const [isOpen, setIsOpen] = useState(false);

  // Track active section while scrolling
  useEffect(() => {
    const sections = [
      "home",
      "mission",
      "values",
      "unique",
      "products",
      "why",
      "contact",
    ];
    const handleScroll = () => {
      const scrollPos = window.scrollY + 100;
      for (let section of sections) {
        const el = document.getElementById(section);
        if (
          el &&
          scrollPos >= el.offsetTop &&
          scrollPos < el.offsetTop + el.offsetHeight
        ) {
          setActiveSection(section);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Form handlers
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch(
      "https://script.google.com/macros/s/AKfycbw01xVryWumfh79tqH99lAlgFf3sKba0twUbDVnuUNu0SyVLLWycrjD3mdnMODhOt_1OQ/exec",
      {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const result = await response.json();
    if (result.result === "success") {
      alert("Message sent successfully!");
      setFormData({ name: "", email: "", phone: "", message: "" });
    } else {
      alert("Failed to send message. Try again!");
    }
  } catch (error) {
    console.error("Error:", error);
    alert("Error sending message!");
  }
};

  return (
    <>
      {/* Navbar */}
      <nav className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
     <Link to="/">          <img src={navlogo} className="w-20 rounded-lg" alt="Logo" /></Link>

          {/* Desktop Menu */}
          <ul className="hidden md:flex space-x-6 text-gray-800 font-medium">
            {["home", "mission", "values", "products", "unique", "why"].map(
              (link) => (
                <li key={link}>
                  <HashLink
                    smooth
                    to={`/#${link}`}
                    scroll={(el) =>
                      setTimeout(
                        () =>
                          el.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                          }),
                        0
                      )
                    }
                    className={`transition ${
                      activeSection === link
                        ? "text-green-700 font-semibold"
                        : "hover:text-green-600"
                    }`}
                  >
                    {link === "unique"
                      ? "Our's Unique"
                      : link === "why"
                      ? "Why Us"
                      : link.charAt(0).toUpperCase() + link.slice(1)}
                  </HashLink>
                </li>
              )
            )}

            {/* Contact Page Link */}
            <li>
              <Link
                to="/contact"
                className={`transition ${
                  activeSection === "contact"
                    ? "text-green-700 font-semibold"
                    : "hover:text-green-600"
                }`}
              >
                Contact
              </Link>
            </li>
          </ul>

          {/* Desktop Button */}
          <a href="#products">
            <button className="hidden md:block bg-gradient-to-r from-green-700 to-green-500 text-white px-5 py-2 rounded-full font-semibold hover:from-green-600 hover:to-green-400 transition shadow-md">
              Shop Now
            </button>
          </a>

          {/* Mobile Hamburger */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-800 text-2xl"
            >
              {isOpen ? "✕" : "☰"}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden bg-white shadow-md px-6 py-4 space-y-4">
            <ul className="space-y-2">
              {[
                "home",
                "mission",
                "values",
                "unique",
                "products",
                "why",
                "contact",
              ].map((link) => (
                <li key={link}>
                  {link === "contact" ? (
                    <Link
                      to="/contact"
                      className={`block transition ${
                        activeSection === link
                          ? "text-green-700 font-semibold"
                          : "hover:text-green-600"
                      }`}
                      onClick={() => setIsOpen(false)}
                    >
                      Contact
                    </Link>
                  ) : (
                    <HashLink
                      smooth
                      to={`/#${link}`}
                      scroll={(el) =>
                        setTimeout(
                          () =>
                            el.scrollIntoView({
                              behavior: "smooth",
                              block: "start",
                            }),
                          0
                        )
                      }
                      className={`block transition ${
                        activeSection === link
                          ? "text-green-700 font-semibold"
                          : "hover:text-green-600"
                      }`}
                      onClick={() => setIsOpen(false)}
                    >
                      {link === "unique"
                        ? "Our's Unique"
                        : link === "why"
                        ? "Why Us"
                        : link.charAt(0).toUpperCase() + link.slice(1)}
                    </HashLink>
                  )}
                </li>
              ))}
            </ul>

            <a href="#products">
              <button className="w-full bg-gradient-to-r from-green-700 to-green-500 text-white px-5 py-2 rounded-full font-semibold hover:from-green-600 hover:to-green-400 transition shadow-md">
                Shop Now
              </button>
            </a>
          </div>
        )}
      </nav>

   {/* Contact Section */}
<section className="bg-white py-24 px-6 mt-16" id="contact">
  <div className="max-w-7xl mx-auto text-center mb-12">
    <h1 className="text-4xl font-extrabold text-[#15803D] mb-4">
      Get In Touch With Us
    </h1>
    <p className="text-gray-600 text-lg max-w-2xl mx-auto">
      Have a question, suggestion, or just want to say hello?  
      We’d love to hear from you — fill out the form below or visit us in person!
    </p>
  </div>

  <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
    {/* Map */}
    <div className="rounded-2xl overflow-hidden shadow-lg">
      
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3923.829801716329!2d79.38620207503709!3d10.4350769896937!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTDCsDI2JzA2LjMiTiA3OcKwMjMnMTkuNiJF!5e0!3m2!1sen!2sin!4v1759766051573!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0, minHeight: "400px" }}
        allowFullScreen=""
        loading="lazy"
        title="Naturals One Location"
      ></iframe>
    </div>

    {/* Contact Form */}
   <div className="bg-[#F0FDF4] rounded-2xl shadow-lg p-8">
  <h2 className="text-2xl font-bold text-[#15803D] mb-6">Contact Us</h2>

  {/* Standard HTML form submission */}
  <form
    action="https://script.google.com/macros/s/AKfycbyqosFn8Va69S0IHsPktimI_FSwTje3LMnkJHjXVK3Ta72WOmm7ULN3-rF2qBgTxerxGg/exec" // replace with your script URL
    method="POST"
    target="_blank" // optional: open in new tab
    className="space-y-5"
  >
    {/* Name */}
    <div>
      <label className="block text-gray-700 mb-2">Name</label>
      <input
        type="text"
        name="name"
        required
        className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-[#15803D] outline-none"
      />
    </div>

    {/* Email */}
    <div>
      <label className="block text-gray-700 mb-2">Email</label>
      <input
        type="email"
        name="email"
        required
        className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-[#15803D] outline-none"
      />
    </div>

    {/* Phone Number */}
    <div>
      <label className="block text-gray-700 mb-2">Phone Number</label>
      <input
        type="tel"
        name="phone"
        required
        maxLength="15"
        placeholder="Enter your phone number"
        className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-[#15803D] outline-none"
      />
    </div>

    {/* Message */}
    <div>
      <label className="block text-gray-700 mb-2">Message</label>
      <textarea
        name="message"
        required
        rows="4"
        className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-[#15803D] outline-none"
      ></textarea>
    </div>

    {/* Submit Button */}
    <button
      type="submit"
      className="w-full bg-[#15803D] text-white py-3 rounded-xl font-semibold hover:bg-green-800 transition"
    >
      Send Message
    </button>
  </form>
</div>

  </div>
</section>


      {/* Footer */}
      <footer className="bg-green-50 text-gray-800 pt-16 pb-2 border-t border-green-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            {/* Brand */}
            <div>
              <div className="flex items-center mb-6">
                <img src={navlogo} className="w-24 rounded-lg" alt="Brand" />
              </div>
              <p className="text-gray-600 leading-relaxed mb-6">
                Refresh your lifestyle with 100% organic coconut products.
                Natural, healthy, and crafted with love.
              </p>
              <div className="flex space-x-4">
                {[
                  { icon: "facebook-f", link: "https://facebook.com" },
                  { icon: "instagram", link: "https://instagram.com" },
                  { icon: "linkedin", link: "https://linkedin.com" },
                ].map(({ icon, link }) => (
                  <a
                    key={icon}
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-green-100 text-green-700 p-3 rounded-full shadow hover:bg-green-700 hover:text-white transition duration-300 transform hover:scale-110"
                  >
                    <i className={`fab fa-${icon}`}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-bold mb-6 text-green-700">
                Quick Links
              </h3>
              <ul className="space-y-3 text-gray-700">
                {[
                  { name: "Home", link: "/#home" },
                  { name: "Mission & Vision", link: "/#mission" },
                  { name: "Our Values", link: "/#values" },
                  { name: "Our Products", link: "/#products" },
                  { name: "What Makes Us Unique", link: "/#unique" },
                  { name: "Why Naturals One", link: "/#why" },
                ].map((item) => (
                  <li key={item.name}>
                    <HashLink
                      smooth
                      to={item.link}
                      className="hover:text-green-700 transition duration-300"
                    >
                      {item.name}
                    </HashLink>
                  </li>
                ))}
              </ul>
            </div>

            {/* Products */}
            <div>
              <h3 className="text-lg font-bold mb-6 text-green-700">
                Products
              </h3>
              <ul className="space-y-3 text-gray-700">
                {[
                    "Vegan Ice Cream",
                    "Coconut Water",
                    "Tender Coconut Chunks  ",
                    "Naturals One Mineral Water",
                    "CocoCarb-Pure Air Mask"
                ].map((product) => (
                  <li key={product}>
                    <a
                      href="/#products"
                      className="hover:text-green-700 transition duration-300"
                    >
                      {product}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-bold text-green-700">Contact Us</h3>
              <h3 className="font-bold text-lg text-green-700 mb-4">
                Naturals One
              </h3>
              <ul className="space-y-4 text-gray-700">
                <li className="flex items-start">
                  <i className="fas fa-map-marker-alt mr-3 text-green-700 mt-1"></i>
                  <span className="text-gray-700 leading-relaxed">
                    No: 1-A, CRS Estate, Regunathapuram, Kasangadu,
                    Pattukkottai, Thanjavur District, Tamilnadu, India - 614613
                  </span>
                </li>
                <li className="flex items-center">
                  <i className="fas fa-phone mr-3 text-green-700"></i>
                  <a href="tel:+919962920850" className="hover:underline">
                    +91-9962920850
                  </a>
                </li>
                <li className="flex items-center">
                  <i className="fas fa-envelope mr-3 text-green-700"></i>
                  <a
                    href="mailto:info@naturalsone.com"
                    className="hover:underline"
                  >
                    info@naturalsone.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom */}
          <div className="mt-12 border-t border-green-200 pt-6 text-center text-gray-500 text-sm">
            © {new Date().getFullYear()}{" "}
            <span className="font-semibold text-green-700">Naturals One</span>.
            All rights reserved.
            <br />
            <span className="mt-1 block">
              Developed by{" "}
              <a
                href="https://alizesoftwareservices.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-700 font-semibold hover:underline"
              >
                Alize Software Services LLP
              </a>
            </span>
          </div>
        </div>
      </footer>
    </>
  );
}
